import { observer } from 'mobx-react-lite'
import { TabItem } from '@/components/TabBar'
import { type TabController } from '@/infra/TabController'

interface TabControllerItemsContainerProps<T> {
  controller: TabController<T>
}

/**
 * Renders the tabs of a tab controller as tab bar items.
 */
export const TabControllerItemsContainer = observer(
  function TabControllerItemsContainer<T>({
    controller,
  }: TabControllerItemsContainerProps<T>) {
    return controller.tabs.map((tab) => (
      <TabItem
        key={String(tab.tab)}
        active={controller.current === tab}
        onPress={() => controller.change(tab.tab)}
        badgeCount={tab.hasError() ? 1 : 0}
      >
        {tab.title}
      </TabItem>
    ))
  },
)
